import { cloneDeep } from 'lodash';

import { KeyValueObject } from '../../../../../shared/models/key-value-object';
import { GT_SEA_VIEW } from '../../../shared/types/sea-view-type';

export const TRANSFER_ATTRIBUTES_MAPPING: KeyValueObject<string> = {
	withTransfer: 'GT14-TR',
	withoutTransfer: 'GT14-WT',
	rentalCar: 'GT14-HC'
};

export const SPORT_ATTRIBUTES_MAPPING: KeyValueObject<string> = {
	aerobics: 'GT03-AERO',
	archery: 'GT03-ARCH',
	badminton: 'GT03-BADM',
	basketball: 'GT03-BASK',
	beachVolleyball: 'GT03-BEVO',
	bowling: 'GT03-BOAL',
	darts: 'GT03-DART',
	golf: 'GT03-GOLF',
	gym: 'GT03-FITN',
	gymnastics: 'GT03-GYMN',
	massages: 'GT03-MASS',
	miniGolf: 'GT03-MINI',
	mountainBike: 'GT03-CYCL/ST03-MOBI',
	squash: 'GT03-SQUA',
	tableTennis: 'GT03-TATE',
	tennis: 'GT03-TENN',
	waterSports: 'GT03-BABO:GT03-CANO:GT03-CATA:GT03-MOBO:GT03-PEBO:GT03-SAIL:GT03-DIVE:GT03-SURF:GT03-AQFI:GT03-WATE:GT03-WIND',
	childCare: 'GT03-ENAC/ST03-CHEN',
	entertainmentProgram: 'GT03-ENAC',
};

export const HOTEL_TYPES_MAPPING: KeyValueObject<string> = {
	historicHotel: 'GT02-HO,GT02-HO/ST02-CA',
	apartmentHotel: 'GT02-HC,GT02-HC/ST02-AC',
	beachHotel: 'GT03-BETO',
	bungalowComplex: 'GT02-HC,GT02-HC/ST02-BC',
	businessHotel: 'GT03-BUTR',
	casinoResort: 'GT03-CASI',
	cityHotel: 'GT03-CITR',
	clubResort: 'GT03-CLTO',
	adultsOnly: 'GT03-ADON',
	conferenceHotel: 'GT03-WOCO',
	ecoHotel: 'GT03-ENFR',
	familyHotel: 'GT03-FAMI',
	finca: 'GT02-HO,GT02-HO/ST02-FI',
	golfHotel: 'GT03-GOTO',
	mountainHotel: 'GT03-MOTO,GT02-HO',
	mountainCottage: 'GT03-MOTO,GT02-HH',
	countryHouse: 'GT02-HH,GT02-HH/ST02-CU',
	skiHotel: 'GT03-WISP',
	spaComplex: 'GT03-SPTO',
	villageHotel: 'GT02-HC,GT02-HC/ST02-VI',
	youthHostel: 'GT03-YOPE,GT02-HO/ST02-HS'
};

export const BEACH_ATTRIBUTES_MAPPING: KeyValueObject<string> = {
	nearToBeach: 'GT03-BEAC,GT03-BEAC/ST03-DIRE',
	parasols: 'GT03-PARA',
	sandyBeach: 'GT03-BEAC,GT03-BEAC/ST03-SAND',
	pebbleBeach: 'GT03-BEAC,GT03-BEAC/ST03-GRAV',
	stonyBeach: 'GT03-BEAC,GT03-BEAC/ST03-ROCK',
	sunLoungers: 'GT03-DECH'
};

export const HOTEL_FACILITY_ATTRIBUTES_MAPPING: KeyValueObject<string> = {
	medicalService: 'GT03-MESP',
	miniClub: 'GT03-KICL',
	withoutSmokingArea: 'GT03-REST/ST03-NO',
	withSmokingArea: 'GT03-REST/ST03-SM',
	laundromat: 'GT03-LAUN',
	wlan: 'GT03-INTE/ST03-WLAN',
	jacuzzi: 'GT03-POOL/ST03-WHJA',
	steamBath: 'GT03-SPAA/ST03-STBA',
	sunTerrace: 'GT03-SUTE',
	sunLoungers: 'GT03-DECH',
	tanningSalon: 'GT03-SOLA',
	sauna: 'GT03-SAUN',
	seaView: cloneDeep(GT_SEA_VIEW)
};

export const POOL_ATTRIBUTES_MAPPING: KeyValueObject<string> = {
	indoorPool: 'GT03-POOL/ST03-INSW',
	outdoorPool: 'GT03-POOL',
	saltWaterPool: 'GT03-POOL/ST03-SEPO',
	childrenPool: 'GT03-POOL/ST03-BAPO',
	heatedPool: 'GT03-POOL/AT03-HEAT',
	freshOrColdWaterPool: 'GT03-POOL/ST03-FRPO',
	poolBar: 'GT03-BARR/ST03-POBA',
};

export const DISTANCE_ATTRIBUTES_MAPPING: KeyValueObject<string> = {
	beach: 'GT03-DIBE',
	busStation: 'GT03-DIBU',
	cityCenter: 'GT03-DICI',
	restaurants: 'GT03-DIRE',
	river: 'GT03-DIWA',
	sea: 'GT03-DISE',
	shopping: 'GT03-DISU',
	skiArea: 'GT03-DISI',
	trainStation: 'GT03-DITR',
};



// WEBPACK FOOTER //
// ./src/app/xena/core/searchform/advanced-search-dialog/shared/mapping.ts